import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { APP_INITIALIZER, ApplicationConfig } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { provideEnvironmentNgxMask, provideNgxMask } from 'ngx-mask';
import { provideToastr } from 'ngx-toastr';
import { firstValueFrom } from 'rxjs';
import { routes } from './app.routes';
import { tenantInterceptor } from './shared/interceptors/tenant.interceptor';
import { InitService } from './shared/services/init.service';
import { WINDOW_PROVIDERS } from './shared/utils/window.token';

// Factory function for app initialization
export function initializeApp(initService: InitService) {
  return () => {
    console.log('🚀 Initializing application - loading tenant configuration...');
    return firstValueFrom(initService.init()).then(
      (config) => {
        // console.log('✅ Tenant configuration loaded successfully:', config);
        return true;
      },
      (error) => {
        console.error('❌ Failed to load tenant configuration:', error);
        // You might want to show an error page or use default values
        return false;
      }
    );
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideEnvironmentNgxMask(),
    provideHttpClient(withInterceptors([tenantInterceptor])),
    provideAnimations(),
    provideToastr(),
    provideNgxMask(),
    ...WINDOW_PROVIDERS,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [InitService],
      multi: true
    }
  ],
};
